const initialState = {
  chatSidebar: false,
  alertData: null
}

const chatSidebar = (state = initialState, action) => {
  switch (action.type) {
    case "CHAT_SIDEBAR":
      return { ...state, chatSidebar: action.val }
    case "CHAT_SIDEBAR_ALERT_DATA":
      return { ...state, alertData: action.val }
    default:
      return state
  }
}
export default chatSidebar
